export default __webpack_public_path__ + "static/media/raccoon_3.1afe86df.png";